const en = {
  nav: {
    home: 'Home',
    sell: 'Sell',
    wanted: 'Wanted',
    favorites: 'Favorites',
    chat: 'Chat',
    orders: 'Orders',
    login: 'Login / Register',
    logout: 'Logout',
    profile: 'Profile',
    dogWalking: 'Dog Walking',
    adoption: 'Adoption',
  },
  hero: {
    title: 'Pet Supplies Marketplace',
    subtitle: 'The best for your pets, the best for the planet',
    searchPlaceholder: 'Search pet supplies...',
  },
  product: {
    price: 'Price',
    condition: 'Condition',
    location: 'Location',
    contactSeller: 'Contact Seller',
    addFavorite: 'Add to Favorites',
  },
  auth: {
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
  },
  common: {
    loading: 'Loading...',
    noResults: 'No results found',
    viewAll: 'View All',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    confirm: 'Confirm',
  },
};

export default en;
